import { useLanguage } from '@/contexts/LanguageContext';
import { cn } from '@/lib/utils';

interface TypeToggleProps {
  isIncome: boolean;
  onToggle: (isIncome: boolean) => void;
  disabled?: boolean;
}

export const TypeToggle = ({ isIncome, onToggle, disabled }: TypeToggleProps) => {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2 p-1 bg-muted rounded-lg">
        <button
          type="button"
          onClick={() => onToggle(false)}
          disabled={disabled}
          className={cn(
            "flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-md text-sm font-medium transition-all",
            "min-h-[44px] touch-manipulation",
            !isIncome
              ? "bg-primary text-primary-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground hover:bg-muted-foreground/10"
          )}
        >
          <span className="text-base">💸</span>
          <span>{t('expense.typeExpense') || 'Expense'}</span>
        </button>
        <button
          type="button"
          onClick={() => onToggle(true)}
          disabled={disabled}
          className={cn(
            "flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-md text-sm font-medium transition-all",
            "min-h-[44px] touch-manipulation",
            isIncome
              ? "bg-success text-success-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground hover:bg-muted-foreground/10"
          )}
        >
          <span className="text-base">💰</span>
          <span>{t('expense.typeIncome') || 'Income'}</span>
        </button>
      </div>
      <p className="text-xs text-muted-foreground text-center">
        {t('expense.typeToggleHint') || 'Tap to change if we guessed wrong'}
      </p>
    </div>
  );
};
